const userRoles = {
  CLIENT: 'CLIENT',
  THERAPIST: 'THERAPIST',
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

export default userRoles;
